/**
 * Algorithm 2: Section Score Calculation
 * Calculate overall section mastery (0-100%)
 * 
 * @param {string} sectionId - ID of section to score
 * @param {Array} allQuestions - Array of all question progress data for this section
 * @returns {number} - Section score (0-100)
 */

export function calculateSectionScore(sectionId, allQuestions) {
  const questionsInSection = allQuestions.filter(q => q.sectionId === sectionId);

  if (questionsInSection.length === 0) return 0;

  // Map difficulty strings to numeric weights
  const getDifficultyWeight = (difficulty) => {
    if (typeof difficulty === 'string') {
      switch (difficulty.toLowerCase()) {
        case 'easy':
          return 1.0;
        case 'medium':
          return 1.5;
        case 'hard':
          return 2.0;
        default:
          return 1.0;
      }
    }
    return 1.0 + (difficulty || 0); // fallback for numeric values
  };

  console.log('=== calculateSectionScore ===');
  console.log('Questions in section:', questionsInSection.length);

  // Weighted average based on difficulty
  let totalWeightedScore = 0;
  let totalWeight = 0;

  questionsInSection.forEach(question => {
    const questionScore = question.currentScore || question.score || 0; // 0-100
    const difficultyWeight = getDifficultyWeight(question.difficulty);
    const weight = difficultyWeight;

    if (isNaN(questionScore)) {
      console.warn('NaN question score for:', question);
    }

    totalWeightedScore += questionScore * weight;
    totalWeight += weight;
  });

  console.log('Total weighted score:', totalWeightedScore, 'Total weight:', totalWeight);

  // Calculate weighted average
  const sectionScore = totalWeightedScore / totalWeight;

  console.log('Final section score:', sectionScore);

  // Round to integer
  return Math.round(sectionScore);
}
